/**
 * AI-generated code, moderated by lzygmanski
 */
import dayjs from 'dayjs';
import {useTranslation} from 'react-i18next';

import {Item} from '@/components/ui/item';
import {Typography} from '@/components/ui/typography';
import type {Event} from '@/services/graphqlHooks';
import {TIME_FORMATS} from '@/utils/timeFormats';

export type AmbulancePrintEventsProps = {
  events: Event[];
};

const AmbulancePrintEvents = ({events}: AmbulancePrintEventsProps) => {
  const {t} = useTranslation();

  if (!events || events.length === 0) return null;

  const sortedEvents = [...events].sort(
    (a, b) => dayjs(b.date).valueOf() - dayjs(a.date).valueOf()
  );

  const groupedEvents = sortedEvents.reduce<Record<string, Event[]>>(
    (acc, event) => {
      const dateKey = dayjs(event.date).format(TIME_FORMATS.awsDate);
      if (!acc[dateKey]) {
        acc[dateKey] = [];
      }
      acc[dateKey].push(event);
      return acc;
    },
    {}
  );

  const sortedDates = Object.keys(groupedEvents).sort(
    (a, b) => dayjs(b).valueOf() - dayjs(a).valueOf()
  );

  return (
    <div className="flex flex-col gap-2">
      <Typography variant="h2" asChild className="text-lg font-semibold">
        <h2>{t('Events')}</h2>
      </Typography>

      <div className="space-y-2">
        {sortedDates.map(dateKey => {
          const dateEvents = groupedEvents[dateKey];

          return (
            <div key={dateKey} className="space-y-2">
              <div className="grid grid-cols-[200px_1fr] gap-2">
                <Item
                  variant="muted"
                  size="compact"
                  className="flex items-center"
                >
                  <Typography className="font-semibold">
                    {dayjs(dateKey).format(TIME_FORMATS.date)}
                  </Typography>
                </Item>

                <Item
                  variant="muted"
                  size="compact"
                  className="flex items-center"
                >
                  <Typography className="font-semibold">
                    {t('Description')}
                  </Typography>
                </Item>
              </div>

              <div className="grid grid-cols-[200px_1fr] gap-2">
                <div />

                <div className="space-y-2">
                  {dateEvents.map(event => (
                    <Item
                      key={event.id}
                      variant="subtle"
                      size="compact"
                      className="flex items-center print:break-inside-avoid"
                    >
                      <Typography>{event.content}</Typography>
                    </Item>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AmbulancePrintEvents;
